import React from 'react';

const COLORS = [
  { cls: 'bg-blue-700', name: 'Blue 700', hex: '#0476D9', dark: true },
  { cls: 'bg-blue-600', name: 'Blue 600', hex: '#3691E1', dark: true },
  { cls: 'bg-blue-500', name: 'Blue 500', hex: '#68ADE8', dark: false },
  { cls: 'bg-blue-400', name: 'Blue 400', hex: '#9BC8F0', dark: false },
  { cls: 'bg-blue-300', name: 'Blue 300', hex: '#5EADF2', dark: false },
  { cls: 'bg-blue-250', name: 'Blue 250', hex: '#99D9F2', dark: false },
  { cls: 'bg-blue-200', name: 'Blue 200', hex: '#CDE4F7', dark: false },
  { cls: 'bg-blue-100', name: 'Blue 100', hex: '#E8F1F9', dark: false },
  { cls: 'bg-gray-900', name: 'Gray 900', hex: '#1D1D1D', dark: true },
  { cls: 'bg-white',    name: 'White',    hex: '#FFFFFF', dark: false },
  { cls: 'bg-gray-100', name: 'Gray 100', hex: '#EFEFEF', dark: false },
];

export default function BackgroundsShowcase() {
  return (
    <div>
      {COLORS.map(({ cls, name, hex, dark }) => (
        <div
          key={cls}
          className={`bg-tile ${cls} ${dark ? 'text-on-dark' : 'text-on-light'}`}
          title={`${name} ${hex}`}
        >
          <span className="label">{name}</span>
          <span className="hex">{hex}</span>
        </div>
      ))}
    </div>
  );
}
